import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarProvider } from "./ui/sidebar";
import { 
  LayoutDashboard, 
  Image, 
  Package2, 
  PackageOpen, 
  Building2, 
  Info, 
  Building, 
  MessageSquare, 
  Mail, 
  Star, 
  Award, 
  LogOut, 
  Hotel
} from "lucide-react";

const adminRoutes = [
  { title: "Dashboard", path: "/admin", icon: LayoutDashboard },
  { title: "Hero", path: "/admin/hero", icon: Image },
  { title: "Packages", path: "/admin/packages", icon: Package2 },
  { title: "Enhanced Packages", path: "/admin/enhanced-packages", icon: PackageOpen },
  { title: "Services", path: "/admin/services", icon: Building2 },
  { title: "About", path: "/admin/about", icon: Info },
  { title: "Company", path: "/admin/company", icon: Building },
  { title: "Social Media", path: "/admin/social", icon: MessageSquare },
  { title: "Social Media Posts", path: "/admin/social-posts", icon: MessageSquare },
  { title: "Messages", path: "/admin/messages", icon: Mail },
  { title: "Email Settings", path: "/admin/email", icon: Mail },
  { title: "Reviews", path: "/admin/reviews", icon: Star },
  { title: "Why Choose Us", path: "/admin/why-choose-us", icon: Award },
  { title: "Accommodations", path: "/admin/accommodations", icon: Hotel }
];

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const { signOut } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  const getNavClass = (isActive: boolean) => 
    `flex items-center gap-2 px-3 py-2 rounded-md transition-colors ${
      isActive ? "bg-muted text-primary font-medium" : "hover:bg-muted/50"
    }`;

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <Sidebar className="w-64 border-r">
          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupLabel>Admin Panel</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {adminRoutes.map((route) => (
                    <SidebarMenuItem key={route.path}>
                      <SidebarMenuButton asChild>
                        <NavLink
                          to={route.path}
                          end={route.path === "/admin"}
                          className={({ isActive }) => getNavClass(isActive)}
                        >
                          <route.icon className="h-4 w-4" />
                          <span>{route.title}</span>
                        </NavLink>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                  <SidebarMenuItem>
                    <SidebarMenuButton
                      onClick={() => signOut()}
                      className="text-destructive hover:bg-muted/50 cursor-pointer"
                    >
                      <LogOut className="h-4 w-4" />
                      <span>Sign Out</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
        </Sidebar>

        <main className="flex-1 p-6 overflow-auto">
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
}